// Require modules
var Util = require( './modules/util' ),
	CloseModal = require( './modules/CloseModal'),
	MailchimpAjax = require( './modules/MailchimpAjax' ),
	openSizeChart = require( './modules/openSizeChart' )
;

// Initialize modules
CloseModal.init();
MailchimpAjax.init();
openSizeChart.init();